/**
 * Created by jv on 09/05/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");
const log = require("Sources/utils/logger")();

var ApplicationServices = {};

(ApplicationServices => {
  ApplicationServices.sendContactForm = function (name, email, message, locale) {
    return request.post({
      url: utils.getServiceUrl("/misc/contact"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      data: {
        name: name,
        email: email,
        message: message,
        locale: locale
      }
    });
  };
})(ApplicationServices);

module.exports = ApplicationServices;



// WEBPACK FOOTER //
// ./app/js/services/application-services.js